import { Checkbox, Col, Modal, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  visible: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  checkedValues: PropTypes.array.isRequired
};

const Modal_UI_UserSelection = ({
  visible,
  data,
  onChange,
  onOk,
  onCancel,
  checkedValues
}) => (
  <Modal
    visible={visible}
    onOk={onOk}
    onCancel={onCancel}
    title={<FormattedMessage id="page.Modals.titles.sharedToUsers" />}
  >
    <Row>
      {data.map(u => (
        <Col span={12} key={u.id}>
          <Checkbox
            checked={checkedValues.indexOf(u.id) > -1}
            onChange={e => onChange(u.id, e)}
            value={u.id}
            className="mb-sm"
          >
            {u.name}
          </Checkbox>
        </Col>
      ))}
    </Row>
  </Modal>
);

Modal_UI_UserSelection.propTypes = propTypes;
export default Modal_UI_UserSelection;



// WEBPACK FOOTER //
// ./src/components/ui/Modals/Modal_UI_UserSelection.jsx